import React from 'react';
import clsx from 'clsx';
import { hooks } from '@lifesize/clients.sdk';
import { colors } from '@lifesize/ux-assets';
import { makeStyles, Theme } from '@material-ui/core';
import ParticipantPresentationButton from 'components/InCall/InCallParticipantList/ParticipantButtons/ParticipantPresentationButton';
import ParticipantMicButton from 'components/InCall/InCallParticipantList/ParticipantButtons/ParticipantMicButton';
import ParticipantRaisedHandButton from 'components/InCall/InCallParticipantList/ParticipantButtons/ParticipantRaisedHandButton';
import ParticipantMoreButton from 'components/InCall/InCallParticipantList/ParticipantButtons/ParticipantMoreButton';

interface Props {
  participant: any;
}

const InCallParticipant = ({ participant }: Props) => {
  const classes = useStyles({});
  const userIsModerator = hooks.useIsCurrentUserModerator();
  const { dialString, isSelf, name } = participant;

  return (
    <div
      data-testid="participant-item"
      className={clsx(classes.participant, userIsModerator && classes.isModerator, isSelf && 'isSelf')}
    >
      <div data-testid="participant-name" className={clsx(classes.name, isSelf && 'isSelf')}>
        {name || dialString}
      </div>
      <div className={classes.buttons}>
        <ParticipantPresentationButton participant={participant} />
        <ParticipantRaisedHandButton participant={participant} />
        <ParticipantMicButton participant={participant} />
        <ParticipantMoreButton participant={participant} />
      </div>
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  participant: {
    alignItems: 'center',
    display: 'flex',
    marginTop: theme.spacing(0.5),
    padding: `0 ${theme.spacing(3)}px`
  },
  name: {
    flex: '1 1 0',
    fontSize: '1.2em',
    padding: '2px 0 1px',
    pointerEvents: 'none',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    '&.isSelf': {
      fontWeight: theme.typography.fontWeightBold
    }
  },
  buttons: {
    alignItems: 'stretch',
    alignSelf: 'stretch',
    display: 'flex',
    flex: '0 0 auto',
    position: 'relative',
    '&>div': {
      position: 'relative'
    },
    '& a:focus': {
      outline: 0
    }
  },
  isModerator: {
    '&:not(.isSelf)': {
      '&:hover': {
        backgroundColor: colors.missionFog
      }
    }
  }
}));

export default InCallParticipant;
